export default __webpack_public_path__ + "static/rawmango-08f7c5b517c5b1a636c6d3f533a75321.png";